import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import addDays from 'date-fns/addDays';
import parse from 'date-fns/parse';
import isAfter from 'date-fns/isAfter';
import DatePicker from 'products/nomad_insurance/components/DatePicker';
import Modal from 'components/Modal';
import { ReactComponent as CheckedIcon } from 'assets/img/icons/checked-icon.svg';
import { isBefore } from 'date-fns';
import { setStartDate, setEndDate, setHasEndDate } from '../../state';
import { DateWrapper, StyledCheckbox } from './styled';

const DateSelection = ({ currentOffer, minStartDate }) => {
  const dispatch = useDispatch();
  const { hasEndDate, startDate, endDate } = useSelector(
    (state) => state.nomadInsurance.purchaseInsurance.coverage
  );
  const [showGiftCardError, setShowGiftCardError] = useState(false);

  const getMaxStartDate = () => {
    if (currentOffer) {
      return parse(currentOffer.maxStartDate, 'yyyy-MM-dd', new Date());
    }
    return new Date();
  };

  useEffect(() => {
    if (minStartDate && isBefore(new Date(startDate), new Date(minStartDate))) {
      dispatch(setStartDate(minStartDate));
    }
  }, [dispatch, minStartDate]); //eslint-disable-line

  // do not allow selecting longer duration than 364 days
  // previously this was possible by selecting latest end date
  // and then moving start date earlier
  useEffect(() => {
    const endDateDate = new Date(endDate);
    const startDateDate = new Date(startDate);
    if (isAfter(endDateDate, addDays(startDateDate, 363))) {
      dispatch(setEndDate(addDays(startDateDate, 363)));
    }
  }, [endDate, startDate, dispatch]);

  return (
    <>
      <DateWrapper>
        <DatePicker
          label="Start date"
          selectedDate={new Date(startDate)}
          minDate={minStartDate}
          maxDate={getMaxStartDate()}
          onDateSelected={(date) => dispatch(setStartDate(date))}
        />
        {hasEndDate && (
          <DatePicker
            label="End date"
            selectedDate={new Date(endDate)}
            minDate={addDays(new Date(startDate), 4)}
            maxDate={addDays(new Date(startDate), 363)}
            onDateSelected={(date) => dispatch(setEndDate(date))}
          />
        )}
      </DateWrapper>
      <StyledCheckbox
        icon={<CheckedIcon />}
        checked={hasEndDate}
        onChange={() => {
          dispatch(setHasEndDate(!hasEndDate));
        }}
      >
        I want to <b> pay upfront </b> for a trip with an end date
      </StyledCheckbox>
      {showGiftCardError && (
        <Modal isOpen={hasEndDate} onClose={() => setShowGiftCardError(false)}>
          <h2>Could not apply gift card</h2>
          <p>
            These gift cards can only be used on insurance policies purchased for 28 days
            or more. If you wish to use your gift card with an end date, please purchase
            insurance policy for 28 days or more.
          </p>
        </Modal>
      )}
    </>
  );
};

DateSelection.propTypes = {
  currentOffer: PropTypes.object,
  minStartDate: PropTypes.string
};

export default DateSelection;
